<!-- Machine data input -->
@if ((processProgressStep$ | async) === 0) {
  <div class="easytram-selection-container">
    <h3>{{ "map.default.easyTramConfiguration.machineSelection.title" | translate }}</h3>
    <form [formGroup]="machineDataForm">
      <div class="easytram-data-input" style="margin-bottom: 25px;">
        <button id="close-image" [ngClass]="{'selected-machine-config-button': selectedMachineConfig === 'cirrus'}" (click)="applyCirrusDefaultConfiguration()">
          <img src="assets/images/cirrus2.svg" alt="Close" width="165" height="85" />
        </button>
        <button id="close-image" [ngClass]="{'selected-machine-config-button': selectedMachineConfig === 'precea'}" (click)="applyPreceaDefaultConfiguration()">
          <img src="assets/images/precea2.svg" alt="Close" width="165" height="85" />
        </button>
      </div>
      <div class="easytram-data-input" style="display: none;">
        <label for="angleMax">
          {{ "map.default.easyTramConfiguration.machineSelection.angleMax" | translate }}:
        </label>
        <input type="number" name="angleMax" min="0.00" step="0.01" formControlName="angleMax">
      </div>
      <div class="easytram-data-input" style="display: none;">
        <label for="speedMax">
          {{ "map.default.easyTramConfiguration.machineSelection.speedMax" | translate }}:
        </label>
        <input type="number" name="speedMax" min="0.00" step="0.01" formControlName="speedMax">
      </div>
      <div class="easytram-data-input" style="display: none;">
        <label for="overlap">
          {{ "map.default.easyTramConfiguration.machineSelection.overlap" | translate }}:
        </label>
        <input type="number" name="overlap" min="0.00" step="0.01" formControlName="overlap">
      </div>
      <hr />
      <div class="easytram-data-input">
        <label for="workingWidthSeeder">
          {{ "map.default.easyTramConfiguration.machineSelection.seeder" | translate }} {{ "map.default.easyTramConfiguration.machineSelection.workingWidth" | translate }}:
        </label>
        <input type="number" name="workingWidthSeeder" min="0" formControlName="workingWidthSeeder">
      </div>
      <div class="easytram-data-input">
        <label for="workingWidthCareDevice">
          {{ "map.default.easyTramConfiguration.machineSelection.careDevice" | translate }} {{ "map.default.easyTramConfiguration.machineSelection.workingWidth" | translate }}:
        </label>
        <input type="number" name="workingWidthCareDevice" min="0" formControlName="workingWidthCareDevice">
      </div>
      <div class="easytram-data-input">
        <label for="trackWidthCareDevice">
          {{ "map.default.easyTramConfiguration.machineSelection.careDevice" | translate }} {{ "map.default.easyTramConfiguration.machineSelection.trackWidth" | translate }}:
        </label>
        <input type="number" name="trackWidthCareDevice" min="0" formControlName="trackWidthCareDevice">
      </div>
      <div class="easytram-data-input">
        <label for="wheelWidthCareDevice">
          {{ "map.default.easyTramConfiguration.machineSelection.careDevice" | translate }} {{ "map.default.easyTramConfiguration.machineSelection.wheelWidth" | translate }}:
        </label>
        <input type="number" name="wheelWidthCareDevice" min="0" formControlName="wheelWidthCareDevice">
      </div>
    </form>
  </div>
}

<!-- Headland configuration -->
@if ((processProgressStep$ | async) === 1) {
  <div class="easytram-selection-container">
    <h3>{{ "map.default.easyTramConfiguration.headlandConfiguration.title" | translate }}</h3>
    <form [formGroup]="headlandForm">
      <div class="easytram-data-input">
        <label for="headlandType">
          {{ "map.default.easyTramConfiguration.headlandConfiguration.type" | translate }}:
        </label>
        <select name="headlandType" formControlName="headlandType">
          <option value="off" [selected]="headlandForm.get('headlandType')?.value === 'off'">
            {{ "map.default.easyTramConfiguration.headlandConfiguration.off" | translate }}
          </option>
          <option value="complete" [selected]="headlandForm.get('headlandType')?.value === 'complete'">
            {{ "map.default.easyTramConfiguration.headlandConfiguration.complete" | translate }}
          </option>
        </select>
      </div>
      <div class="easytram-data-input">
        <label for="headlandWidth">
          {{ "map.default.easyTramConfiguration.headlandConfiguration.width" | translate }}:
        </label>
        <input type="number" name="headlandWidth" min="0" formControlName="headlandWidth">
      </div>
      <div class="easytram-data-input">
        <mat-slide-toggle
          hideIcon="true"
          labelPosition="before"
          [checked]="headlandForm.get('withTramlines')?.value"
          [disabled]="headlandForm.get('headlandType')?.value !== 'complete'"
          (change)="switchWithTramlines($event)"
          >
          {{ "map.default.easyTramConfiguration.headlandConfiguration.withTramlines" | translate }}:
        </mat-slide-toggle>
      </div>
      <div style="display: flex; justify-content: flex-end;">
        <button class="btn-small btn-blue-secondary apply-button" (click)="applyHeadlandConfiguration()">
          {{ 'map.default.easyTramConfiguration.applyButton' | translate }}
        </button>
      </div>
    </form>
  </div>
}

<!-- Mainland configuration -->
@if ((processProgressStep$ | async) === 2) {
  <div class="easytram-selection-container">
    <h3>{{ "map.default.easyTramConfiguration.coreLandConfiguration.title" | translate }}</h3>
    <form [formGroup]="corelandForm">
      <div class="easytram-data-input">
        <mat-slide-toggle
          hideIcon="true"
          labelPosition="before"
          [checked]="corelandForm.get('showCoverage')?.value"
          (change)="switchShowCoverage($event)"
          >
          {{ "map.default.easyTramConfiguration.coreLandConfiguration.showCoverage" | translate }}:
        </mat-slide-toggle>
      </div>
      <hr />
      @if (easyTramPlan?.corelandBaseSegment === undefined) {
        <div class="easytram-warning-text">
          {{ "map.default.easyTramConfiguration.coreLandConfiguration.selectTramlineWarning" | translate }}
        </div>
      }
      @if (easyTramPlan?.corelandBaseSegment !== undefined && !easyTramPlan?.validateCorelandConfiguration()) {
        <div class="easytram-warning-text">
          {{ "map.default.easyTramConfiguration.coreLandConfiguration.invalidConfigurationWarning" | translate }}
        </div>
      }
      <div class="easytram-data-input">
        <label for="shiftOffset">
          {{ "map.default.easyTramConfiguration.coreLandConfiguration.shiftOffset" | translate }}:
        </label>
        <input type="number" name="shiftOffset" formControlName="shiftOffset">
      </div>
      <div class="easytram-data-input">
        <label for="degreeOffset">
          {{ "map.default.easyTramConfiguration.coreLandConfiguration.degreeOffset" | translate }}:
        </label>
        <input type="number" name="degreeOffset" min="-360" max="360" formControlName="degreeOffset">
      </div>
      <div style="display: flex; justify-content: flex-end;">
        <button class="btn-small btn-blue-secondary apply-button" (click)="applyCorelandConfiguration()">
          {{ 'map.default.easyTramConfiguration.applyButton' | translate }}
        </button>
      </div>
    </form>
  </div>
}